import React from "react";
import { Card } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "./styles.css";

import SwiperCore, { Pagination } from "swiper/core";

import { Autoplay } from "swiper";

SwiperCore.use([Pagination]);
SwiperCore.use([Autoplay]);

const Project = (props) => {
  const { image, name, description, tech, link, github } = props.project;
  // console.log(name,tech);

  return (
    <div className="col-md-4 col-sm-12 mb-5 myCard">
      <Card>
        <Swiper
          direction={"vertical"}
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 4000,
          }}
          className="mySwiper"
        >
          {image.map((img) => (
            <SwiperSlide>
              <img src={img} alt="" srcset="" />
            </SwiperSlide>
          ))}
        </Swiper>

        <Card.Body
          style={{ backgroundColor: "rgb(217 207 207 / 91%)", color: "black" }}
        >
          <Card.Title style={{ color: "#df5c04", fontWeight: "900" }}>
            {name}
          </Card.Title>
          <Card.Text>{description}</Card.Text>
          <div className="d-flex justify-content-start flex-wrap mb-3">
            {tech.map((tech) => (
              <div
                style={{
                  background: "#6c63fe",
                  color: "white",
                  margin: "1px 2px",
                  padding: "2px 4px",
                  borderRadius: "3px",
                }}
              >
                {tech}
              </div>
            ))}
          </div>
          <a
            href={link}
            style={{ textDecoration: "none", color: "whitesmoke" }}
          >
            <button className="project-btn">
              {" "}
              <img
                src="https://img.icons8.com/material-rounded/20/26e07f/link--v2.png"
                className="mx-1"
                alt=""
              />
              Live Link
            </button>
          </a>
          <a
            href={github}
            style={{ textDecoration: "none", color: "whitesmoke" }}
          >
            <button className="project-btn">
              <img
                src="https://img.icons8.com/color/24/26e07f/github--v1.png"
                className="mx-1"
                alt=""
              />
              Github
            </button>
          </a>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Project;
//
